<template>
  <div class="v2-viewer card border-0 shadow-sm">
    <div class="card-body p-2">
      <div v-if="!selectedEventoId" class="v2-empty text-muted">
        Selecione um evento na coluna 1 para visualizar o vídeo.
      </div>

      <div v-else>
        <div class="v2-title" v-if="item.evento && item.evento.nome">
          {{ item.evento.nome }}
        </div>

        <div class="v2-loading" v-if="loading">Carregando transmissão...</div>
        <div class="v2-error" v-if="item.erro">{{ item.erroMensagem || "Erro ao carregar evento" }}</div>

        <div v-if="!item.erro" class="v2-player-wrap">
          <div
            class="row rowOpenvidu"
            v-bind:style="{ display: item.evento && item.evento.servidorTipo == 'openvidu' ? 'block' : 'none' }"
          >
            <div class="col-12 text-center p-0">
              <div id="subscriber"></div>
            </div>
          </div>

          <div
            class="row rowAnt"
            v-bind:style="{ display: item.evento && item.evento.servidorTipo == 'ant' ? 'block' : 'none' }"
          >
            <div class="col-12 text-center p-0">
              <video id="remoteVideo" autoplay controls playsinline></video>
            </div>
          </div>

          <div
            class="row rowFlash"
            v-bind:style="{ display: item.evento && item.evento.servidorTipo == 'sh' ? 'block' : 'none' }"
          >
            <div class="col-12 text-center p-0">
              <div id="playFlash">
                <video id="flashPlayVideo" controls="controls"></video>
              </div>
            </div>
          </div>

          <div
            class="row rowMS"
            v-bind:style="{ display: item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none' }"
          >
            <div class="col-12 text-center p-0">
              <video id="msPlayVideo" autoplay controls playsinline :muted="audioMudo"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiAnt } from "@/services/apiAnt.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";

export default {
  name: "V2EventViewer",
  props: {
    selectedEventoId: { type: String, default: "" },
  },
  data() {
    return {
      loading: false,
      item: {
        evento: null,
        erro: false,
        erroMensagem: "",
      },
    };
  },
  watch: {
    selectedEventoId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.carregarItem(newVal);
        } else {
          this.item = { evento: null, erro: false, erroMensagem: "" };
        }
      },
    },
  },
  computed: {
    audioMudo() {
      return (
        this.$sessao &&
        this.$sessao.usuario &&
        (this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador")
      );
    },
  },
  methods: {
    async carregarItem(id) {
      this.loading = true;
      this.item.erro = false;
      this.item.erroMensagem = "";

      try {
        const response = await api.get("/evento/view/" + id);

        if (response.data.erro == false && response.data.itens.length > 0) {
          const evento = response.data.itens[0];
          evento.servidorTipo = evento.servidorTipo ? evento.servidorTipo : "openvidu";

          this.item.evento = evento;
          this.item.erro = false;

          this.$nextTick(async () => {
            try {
              if (evento.servidorTipo == "openvidu") {
                apiOpenVidu.entrarSessaoB(evento);
              } else if (evento.servidorTipo == "ant") {
                apiAnt.view(evento);
              } else if (evento.servidorTipo == "sh") {
                apiFlashphoner.initStream();
                apiFlashphoner.connectPlay(evento.key, evento, evento.canal);
              } else if (evento.servidorTipo == "ms") {
                apiMS.setUrl(evento.servidor);
                apiMS.setToken(evento.msToken);
                await apiMS.connect({ subscribe: true });
              }
            } catch (e) {
              this.item.erro = true;
              this.item.erroMensagem = "Falha ao iniciar o player";
            }
          });
        } else {
          this.item.erro = true;
          this.item.erroMensagem = response.data.mensagem || "Evento não encontrado";
        }
      } catch (e) {
        this.item.erro = true;
        this.item.erroMensagem = "Erro ao carregar evento";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v2-viewer {
  min-height: 320px;
}

.v2-empty {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v2-loading {
  color: #475569;
  margin-bottom: 8px;
}

.v2-error {
  color: #dc2626;
  margin-bottom: 8px;
}

.v2-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #111827;
}

.v2-player-wrap video {
  width: 100%;
  max-height: 420px;
  background: #000;
}

#subscriber {
  width: 100%;
  min-height: 280px;
  background: #000;
}
</style>
